module.exports = __webpack_public_path__ + "img/sponsored_by_intuit.e0381da1.svg";